import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

const { downShelfIsBargain } = httpApi.shopManage;

// 商品下架判断是否还价
interface DownShelfIsBargainParams {
  commodity_id: string;
}

export const apiDownShelfIsBargain = (json: DownShelfIsBargainParams): any =>
  http.httpPost({
    url: downShelfIsBargain,
    json,
  });
